// ═══════════════════════════════════════════════════════════════════════════════
// Inventory expiry summary window (modal / stats) — aligned with notify lead days
// ═══════════════════════════════════════════════════════════════════════════════
import { INVENTORY_EXPIRING_SOON_WINDOW_CALENDAR_DAYS } from '../constants/index.js';
const ALLOWED_NOTIFY_EXPIRY_LEAD_DAYS = new Set([3, 7, 10, 14, 30]);
/** Query flag: open Home Stock "expiring soon" detail modal after navigation. */
export const INVENTORY_OPEN_EXPIRING_QUERY_PARAM = 'openExpiring';
export const parseInventoryNotifyExpiryLeadDays = (raw) => {
    if (!Array.isArray(raw)) {
        return [];
    }
    return raw.filter((n) => typeof n === 'number' && Number.isInteger(n) && ALLOWED_NOTIFY_EXPIRY_LEAD_DAYS.has(n));
};
const diffCalendarDaysYmd = (fromYmd, toYmd) => {
    const parseUtc = (ymd) => {
        const [y, m, d] = ymd.split('-').map((part) => parseInt(part, 10));
        return Date.UTC(y, m - 1, d);
    };
    return Math.round((parseUtc(toYmd) - parseUtc(fromYmd)) / 86_400_000);
};
/** Summary modal window: max configured lead day, or 7 when employer set none. */
export const resolveInventoryExpiringSoonWindowDays = (notifyExpiryLeadDays) => {
    const parsed = parseInventoryNotifyExpiryLeadDays(notifyExpiryLeadDays);
    if (parsed.length === 0) {
        return INVENTORY_EXPIRING_SOON_WINDOW_CALENDAR_DAYS;
    }
    return Math.max(...parsed);
};
/** Past-due always included; otherwise within resolved window (inclusive). */
export const shouldSurfaceInventoryExpiryForSummary = (todayYmd, expiryYmd, notifyExpiryLeadDays) => {
    const diff = diffCalendarDaysYmd(todayYmd, expiryYmd);
    if (diff < 0) {
        return true;
    }
    const windowDays = resolveInventoryExpiringSoonWindowDays(notifyExpiryLeadDays);
    return diff <= windowDays;
};
const readQueryParam = (search, key) => {
    const normalized = search.startsWith('?') ? search.slice(1) : search;
    if (normalized === '') {
        return null;
    }
    for (const part of normalized.split('&')) {
        if (part === '') {
            continue;
        }
        const eqIdx = part.indexOf('=');
        const rawKey = eqIdx === -1 ? part : part.slice(0, eqIdx);
        const rawValue = eqIdx === -1 ? '' : part.slice(eqIdx + 1);
        if (decodeURIComponent(rawKey) === key) {
            return decodeURIComponent(rawValue);
        }
    }
    return null;
};
export const isInventoryOpenExpiringSearch = (search) => readQueryParam(search, INVENTORY_OPEN_EXPIRING_QUERY_PARAM) === '1';
export const appendInventoryOpenExpiringQuery = (path) => {
    const separator = path.includes('?') ? '&' : '?';
    return `${path}${separator}${INVENTORY_OPEN_EXPIRING_QUERY_PARAM}=1`;
};
//# sourceMappingURL=inventoryExpiryWindow.js.map